import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {TopPerformersWidgetController} from "../top-performers-widget.controller";
import {TopPerformersWidgetState} from "../models/top-performers-widget.state";
import {TOP_PERFORMERS_WIDGET} from "../top-performers-consts";
import {TopPerformersWidgetAnalyticsDisplayEvent} from "../models/top-performers-widget.analytics-display.event";

export class TopPerformersWidgetAnalyticsDisplayHandler extends AnalyticsEventHandler {
  state: TopPerformersWidgetState;
  controller: TopPerformersWidgetController;
  type = TOP_PERFORMERS_WIDGET.ACTION_TYPES.displayHandler;

  static injectables = [AnalyticsService];

  constructor(analyticsService: AnalyticsService) {
    super(analyticsService);

    this.eventType = TopPerformersWidgetAnalyticsDisplayEvent;
  }
}
